import { IContactFormData } from 'src/SharedCustomHooks/UseContactFormData/types';

const normalizePropertyKeys = (properties: any[]): any[] => {
  if (!properties || !Array.isArray(properties)) return [];

  return properties.map((property: any) => {
    const { id, Id, propertyId, ...rest } = property;
    return {
      ...rest,
      propertyId: propertyId || id || Id,
    };
  });
};

const sanitizeContactData = (data: IContactFormData): IContactFormData => {
  const sanitizedData = { ...data };

  const fieldsToTrim: (keyof IContactFormData)[] = [
    'firstname',
    'lastname',
    'email',
    'phone'
  ];

  fieldsToTrim.forEach((field) => {
    if (typeof sanitizedData[field] === 'string') {
      // @ts-ignore - We already checked that it is a string above
      sanitizedData[field] = sanitizedData[field].trim();
    }
  });

  return sanitizedData;
};

export { normalizePropertyKeys, sanitizeContactData };
